export enum ESitSupportAT {
	feuilletAT = 0,
	attestationAffiliation = 1,
	courrierCaisse = 2,
	declarationDeLaVictime = 3
}
